var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],staticClass:"h-100",attrs:{"id":"admin-app"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }